export function linkUsed() {
    // return `https://api.my3dvision.com`
    return `https://kckarmalv4.execute-api.ap-southeast-1.amazonaws.com`
}